import React, { FC } from "react";
import { Col, Row } from "antd";
import { MatterStatusSelectorDropdown } from "../matter-status-selector-dropdown";
import { MatterExternalOrCustomEditor } from "../matter-external-or-custom-editor";

import {
  Matter,
  NewClientValue,
  MatterExternalMatterUpdate,
  MatterStatusUpdate,
  LibraryFeeEarners,
  MatterNonExternalFieldsUpdate,
  PracticeArea,
  ClientFilterData,
  ExternalMatterData,
  MatterType,
  MatterFormMode,
} from "../../data-types";

import styles from "./matter-editor-header-and-template.css";

const {
  ["grid"]: gridClassName,
  ["subheading"]: subheading,
  ["matter-editor-header"]: gridMatterEditorHeaderClassName,
  ["matter-status-selector-dropdown-holder"]: matterStatusSelectorDropdownHolder,
  ["matter-external-or-custom-editor"]: matterExternalOrCustomEditor,
} = styles as any;

type MatterEditorHeaderProps<T extends MatterType, U extends MatterFormMode> = {
  matter: Matter;
  pmsName: string;
  practiceAreas: PracticeArea[];
  onClientSave: (newClient: NewClientValue) => void;
  onMatterExternalMatterUpdate: (matter: MatterExternalMatterUpdate) => Promise<void>;
  onMatterUpdate: (matter: MatterNonExternalFieldsUpdate<T, U>) => Promise<void>;
  onMatterStatusUpdate: (matter: MatterStatusUpdate) => Promise<void>;
  clientFilterData: ClientFilterData;
  externalMatterData: ExternalMatterData;
  feeEarners: LibraryFeeEarners[];
};

export const MatterEditorHeader = <T extends MatterType, U extends MatterFormMode>({
  matter,
  pmsName,
  practiceAreas,
  onClientSave,
  onMatterExternalMatterUpdate,
  onMatterUpdate,
  onMatterStatusUpdate,
  clientFilterData,
  externalMatterData,
  feeEarners,
}: MatterEditorHeaderProps<T, U>): ReturnType<FC<MatterEditorHeaderProps<T, U>>> => {
  const { id, status, reference } = matter;
  return (
    <>
      <Row className={`${gridClassName} ${gridMatterEditorHeaderClassName}`} gutter={16}>
        <Col span={14}>
          <MatterExternalOrCustomEditor
            matter={matter}
            externalMatterData={externalMatterData}
            feeEarners={feeEarners}
            pmsName={pmsName}
            practiceAreas={practiceAreas}
            onClientSave={onClientSave}
            onMatterExternalMatterUpdate={onMatterExternalMatterUpdate}
            onMatterUpdate={onMatterUpdate}
            clientFilterData={clientFilterData}
            className={matterExternalOrCustomEditor}
          />
        </Col>
        <Col span={5}>
          <span className={subheading}>Status: </span>
          <div className={matterStatusSelectorDropdownHolder}>
            <MatterStatusSelectorDropdown
              isParent={matter.isParent ?? false}
              status={status}
              id={id}
              reference={reference}
              onUpdate={onMatterStatusUpdate}
              externalMatterId={matter.externalMatterId}
              pmsName={pmsName}
            />
          </div>
        </Col>
        <Col span={5}></Col>
      </Row>
    </>
  );
};
